import { render, staticRenderFns } from "./FileIcons.vue?vue&type=template&id=691c73fe&scoped=true"
import script from "./FileIcons.vue?vue&type=script&lang=js"
export * from "./FileIcons.vue?vue&type=script&lang=js"
import style0 from "./FileIcons.vue?vue&type=style&index=0&id=691c73fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c73fe",
  null
  
)

export default component.exports